import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Card, Tooltip, Spin, Avatar, Tag, Tabs, Button } from 'antd';
import { Context } from '../context';
import { Appearer } from './Appearer';
import { LinkedinFilled, GlobalOutlined, InstagramOutlined, EllipsisOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { AlumniCard } from './AlumniCard';
import categories_colors from '../static/categories_colors.json';

const Main = () => {

  useEffect(() => {
    document.title = `Gnomon Alumni`;
  }, []);

  const context = useContext(Context);
  const alumni = context.alumni;
  const categories = context.categories;

  const [filtered, setFiltered] = useState(alumni.filter(one => context.state.filterCategories ? one.categories.includes(context.state.filterCategories) : true) || []);

  useEffect(() => {
    setFiltered(alumni.filter(one => context.state.filterCategories ? one.categories.includes(context.state.filterCategories) : true) || []);
  }, [context.alumni, context.state.filterCategories]);


  // useEffect(() => {
  //   console.log('filtered = ', filtered);
  // }, [filtered]);


  const cats = categories.sort((a, b) => {
    const alumniIds = context.alumni.map(one => one._id);
    return b.alumni.filter(one => alumniIds.includes(one)).length - a.alumni.filter(one => alumniIds.includes(one)).length
  })


  const getColumns = (length) => {
    switch (length) {
      case 0:
      case 1:
        return { xs: 24, sm: 24, md: 18, lg: 18 };
      case 2:
        return { xs: 24, sm: 12, md: 12, lg: 12 };
      case 3:
        return { xs: 24, sm: 12, md: 8, lg: 8 };
      default:
        return { xs: 24, sm: 8, md: 8, lg: 6 };
    }
  };

  const columns = getColumns(filtered.length);

  const operations = <div style={{ marginRight: '1em' }}>
    <Button size='small' type={context.state.filterCategories ? 'primary' : 'default'} onClick={() => {
      context.state.setFilterCategories()
    }}>
      All
      <Tag color={'#222222'} style={{ padding: '0.2em 0.4em', lineHeight: '1em', margin: 0, color: 'currentColor', backgroundColor: '#ffd40b' }}>{context.alumni.length}</Tag>
    </Button></div>;

  return (<div style={{ padding: '0' }}>
    {alumni.length === 0 ? (
      <div className='_fcc _fv y _fgap2' style={{ minHeight: '80vh' }}>
        <Spin size="large" />
        <div >
          Loading
        </div>
      </div>
    ) : (
      <div className='_fv _fgap2'>
        <div className='_fc _fgap1 _fwrap'>
          <Tabs
            // tabBarExtraContent={{ left: operations }}
            defaultActiveKey={null}
            style={{
              width: '100%',
            }}
            onTabClick={(key) => {
              context.state.setFilterCategories(key === 'all' ? null : context.categories.find(one => one._id === key).title)
            }}
            items={[
              {
                title: <Button
                  size='small'
                  type={context.state.filterCategories ? 'primary' : 'default'}
                  onClick={() => {
                    context.state.setFilterCategories()
                  }}
                >
                  All
                  <Tag color={'currentColor'} style={{ padding: '0.2em 0.4em', lineHeight: '1em', margin: 0, backgroundColor: '#0000002f' }}>{context.alumni.length}</Tag>
                </Button>,
                _id: 'all',
                alumni: [...context.alumni.map(one => one._id)]
              },
              ...cats
            ]
              .filter(category => {
                return category.alumni.filter(one => context.alumni.map(two => two._id).includes(one)).length > 0
              }
              )
              .map((category) => ({
                label: <div className='_f _fcc _fgap04'><span>{category.title}</span> {category._id !== 'all' && <Tag color={'#222222'} style={{ padding: '0.2em 0.4em', lineHeight: '1em', margin: 0, color: 'currentColor' }}>{category.alumni.filter(one => context.alumni.map(two => two._id).includes(one)).length}</Tag>}</div>,
                key: category._id,
                children: (
                  <div>
                    <Row gutter={16} justify="center">
                      {filtered
                        .map((entry, index) => (
                          <Col {...columns} key={entry._id}
                          >
                            <Appearer order={index}>
                              <AlumniCard entry={entry} />
                            </Appearer>
                          </Col>
                        ))}
                    </Row>
                  </div>
                ),
              }))}
          />


        </div>




      </div>
    )}
  </div>);
};

export default Main;